export default __webpack_public_path__ + "static/media/prata.ee8bcf8c.png";